import {WorkExperienceType} from '../../models/work-experience.model';

export interface WorkExperienceCreateData {
  accountId: string;
  organizationId: string;
  employmentTenure: string;
  isCurrentlyWorking: boolean;
  jobTitleId: string;
  jobDescription: string;
  type: WorkExperienceType;
  location?: string;
}

export class WorkExperienceCreateParams {
  accountId: string;
  organizationId: string;
  employmentTenure: string;
  isCurrentlyWorking: boolean;
  jobTitleId: string;
  jobDescription: string;
  type: WorkExperienceType;
  location?: string;

  constructor(data: WorkExperienceCreateData) {
    this.accountId = data.accountId;
    this.organizationId = data.organizationId;
    this.employmentTenure = data.employmentTenure;
    this.isCurrentlyWorking = data.isCurrentlyWorking;
    this.jobTitleId = data.jobTitleId;
    this.jobDescription = data.jobDescription;
    this.type = data.type;
    this.location = data.location;
  }
}

export interface WorkExperienceUpdateParams {
  organizationId?: string;
  employmentTenure?: string;
  isCurrentlyWorking?: boolean;
  jobTitleId?: string;
  jobDescription?: string;
  type?: WorkExperienceType;
  location?: string;
}
